<template>
  <div v-if="isAuthenticated">
    <div class="dropdown d-flex align-items-center justify-content-center nav-link h-100" href="#">
      <NotificationBell :notificationType="notificationType"
                        :iconClass="iconClass"
                        :notification-count="notificationCount"
                        @click="toggleNotificationMenu"
      />
      <notification-list
        :notifications="notifications"
        :txt-options="TXT_OPTIONS"
        :notification-type="notificationType"
        @mark-as-read="handleMarkAsRead"
        @mark-all-read="handleMarkAllRead"
        @redirect="handleRedirect"
      />
    </div>
  </div>
</template>

<script>
import NotificationBell from './components/NotificationBell.vue';
import NotificationList from "@/components/NotificationList.vue";

export default {
  components: {
    NotificationBell,
    NotificationList,
  },
  props: ['notificationType', 'iconClass'],
  data() {
    return {
      notificationCount: 0,
      notifications: [],
      webSocket: null,
      showNotifications: false, // Just used to know if the list is visible to mark the notifications as seen
      TXT_OPTIONS: window.TXT_OPTIONS,
      userid: window.USER_ID,
      notificationType: this.notificationType,
      base_url: this.getBaseUrl()
    };
  },
  computed: {
    isAuthenticated() {
      return window.USER_ID != null;
    },
  },
  mounted() {
    // console.log('Received notificationType in App.js:', this.notificationType);
    //console.log("NODE_ENV:", process.env.NODE_ENV);
    //console.log("Full process.env:", process.env);
    document.addEventListener('click', this.handleClickOutside);
    this.establishWebSocketConnection();
  },

  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    getBaseUrl() {
      const isProductionDomain = window.location.hostname === 'meetero.com' || window.location.hostname === 'www.meetero.com';

      if (isProductionDomain) {
        // Use the env variable, or fallback to a relative secure URL based on the current domain
        return process.env.VUE_APP_HTTPS_URL || `https://${window.location.host}/`;
      }
      if (process.env.NODE_ENV === 'development') {
        return 'http://127.0.0.1:8001/'
        }
      // Fallback
      return process.env.VUE_APP_HTTPS_URL || `https://${window.location.host}/`;
    },
    /* The notification list must close when the user clicks outside it */
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showNotifications = false;
      }
    },
    async establishWebSocketConnection() {
      if (!this || !this.userid) {
        console.log("user not authenticated")
        return; // Silently exit if 'this' is invalid or no user ID
      }
      const ws_url = this.base_url;
      this.webSocket = new WebSocket(`${ws_url}websocket/ws/notifications/${this.userid}/`);

      // console.log("User id: "+this.userid);
      this.webSocket.onopen = () => {
        //console.log('Connection established!');
        //console.log("We are in "+process.env.NODE_ENV)
        this.updateNotificationCount();
      };
      this.webSocket.onmessage = (event) => {
        const message = JSON.parse(event.data);
        //console.log("Notification type "+this.notificationType);

        if ((message.type === 'notification.update' && this.notificationType === 'general') ||
          (message.type === 'notification.update.' + this.notificationType)) {
          this.notificationCount = message.count;
          this.notifications = message.notifications.map(notification => ({
            id: notification.id,
            is_read: notification.is_read,
            message: notification.message,
            redirect_url: notification.redirect_url
          }));
        } else if (this.notificationType === 'general') {
          this.updateNotificationCount();
        } else {
          //console.log("Different type of Notification! "+this.notificationType);
        }
      };

      this.webSocket.onclose = () => {
        //console.log('Connection closed.');
        // implement reconnect logic if desired
      };
    },
    /* This will reset the notification count setting all the unseen notifications as seen */
    toggleNotificationMenu() {
      this.showNotifications = !this.showNotifications;
      //console.log("Notification count:" + this.notificationCount)
      if (this.showNotifications && this.notificationCount > 0) {
        this.webSocket.send(JSON.stringify({
          type: "mark.all.seen",
          notificationType: this.notificationType
        }));
      }
    },
    /* This method is called when the user clicks on a single notification to mark it as read */
    handleMarkAsRead(id) {
      this.webSocket.send(JSON.stringify({
        type: "mark.one.read",
        id: id,
        notificationType: this.notificationType
      }));
    },
    handleRedirect(redirect_url) {
      if (redirect_url) {
        window.location.href = redirect_url;
      }
    },
    // This will mark all the notifications as read
    handleMarkAllRead() {
      this.webSocket.send(JSON.stringify({
        type: "mark.all.read",
        notificationType: this.notificationType
      }));
    },
    // This will update the notification counter.
    updateNotificationCount() {
      // Send a message to the WebSocket server to request updated notification count
      this.webSocket.send(JSON.stringify({
        type: "update.notification.count",
        notificationType: this.notificationType
      }));
    },
  },
};
</script>
